import React from "react";

//material ui
import Link from "@material-ui/core/Link";

const LoginFormContentBottomText = ({ classes }) => {
  return (
    <p className={classes.bottomText}>
      The Weaviate Console allows you to create Weaviate clusters that are
      hosted by Weaviate. For more information, email us at{" "}
      <Link className={classes.links} href="mailto:hello@weaviate.io">
        hello@weaviate.io
      </Link>
    </p>
  );
};

export default LoginFormContentBottomText;
